import { render } from "./ResetPasswordPage.vue?vue&type=template&id=65bb990a"
import script from "./ResetPasswordPage.vue?vue&type=script&lang=js"
export * from "./ResetPasswordPage.vue?vue&type=script&lang=js"

import "./ResetPasswordPage.vue?vue&type=style&index=0&id=65bb990a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__